import React, { Fragment, useEffect, useState } from 'react'
import { useStyles } from './style'
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  Paper,
  Typography,
  Tooltip,
  IconButton,
  Fade,
  useMediaQuery,
  useTheme,
  TextField,
  Button
} from '@mui/material'
import { CardChart } from '../../components/Charts/CardChart/CardChart'
import { HorizontalBarChart } from '../../components/Charts/HorizontalBarChart/HorizontalBarChart'
import { numberWithPoints } from '../../utils/parsers'
import { PopOverMenu } from '../../components/PopOverMenu/PopOverMenu'
import { apiCall, ApiConfig } from '../../config/api'
import {
  // DashBoardItems,
  // DashBoardTotals,
  DashBoardPicking
} from '../../interfaces/DashBoard/DashBoard'
import { useWarehouses } from '../../hooks/useWarehouses'
import { useZones } from '../../hooks/useZones'
import { Selector } from '../../components/Selector/Selector'
import RefreshIcon from '@mui/icons-material/Refresh'
import { EnumIndicadores, enumTipoIndicador } from './config'
// import { orderDictionary } from './config'
// import { dynamicSort } from '../../utils/helpers'
import { graphLoader } from '../../images/graphLoader'
import { DateTime, Interval } from 'luxon'
import { SnackBar } from '../../components/SnackBar/Snackbar'

interface DashBoardPageProps {}

export const DashBoardPage: React.FC<DashBoardPageProps> = () => {
  const theme = useTheme()
  const matchesLG = useMediaQuery(theme.breakpoints.up('lg'))
  const [pickingReportData, setPickingReportData] = useState<
    DashBoardPicking | undefined
  >()

  const [wareHouse, setWareHouse] = useState<number>(0)
  const [zone, setZone] = useState<number>(0)
  const [indicator, setIndicator] = useState<number>(1)
  // const [sorter, setSorter] = useState<number>(0)
  const [dataIndicator, setDataIndicator] = useState<number[]>([])
  const [loading, setLoading] = useState<boolean>(false)

  const classes = useStyles()
  const cardSize = {
    maxWidth: 260,
    maxHeight: 130
  }

  let categories: string[] | undefined = []
  let dataUnidadesPickeadas: number[] | undefined = []
  let dataUnidadesPromedio: number[] | undefined = []
  let dataTiempoTrabajado: number[] | undefined = []
  let dataVariable: number[] | undefined = []

  const [snackBar, setSnackBar] = useState({
    open: false,
    message: '',
    status: ''
  })

  const {
    warehousesState: { warehouses },
    getWarehouses
  } = useWarehouses()

  useEffect(() => {
    if (warehouses?.length === 0) {
      getWarehouses()
    }
  }, [])

  const {
    zonesState: { zones },
    getZones
  } = useZones()

  useEffect(() => {
    if (zones?.length === 0) {
      getZones()
    }
  }, [])

  const initialData = {
    initialDate: `${
      DateTime.utc().toLocal().toFormat("yyyy-MM-dd'T'HH:mm").split('T')[0]
    }T01:00`,
    finalDate: DateTime.utc().toLocal().toFormat("yyyy-MM-dd'T'HH:mm")
  }

  const [timeFilter, setTimeFilter] = useState(initialData)

  const [error, setError] = useState(false)

  const handleChangeDateTime = ({ target }: any) => {
    setTimeFilter({
      ...timeFilter,
      [target.name]: target.value
    })
  }

  const handleGetDataDashBoard = () => {
    setLoading(true)
    let warehouseId: string = ''
    let zoneId: string = ''
    let initialDate: string = ''
    let finalDate: string = ''

    initialDate = `InitialDate=${
      DateTime.fromISO(timeFilter.initialDate).toUTC().toString().split('Z')[0]
    }`
    finalDate = `&FinalDate=${
      DateTime.fromISO(timeFilter.finalDate).toUTC().toString().split('Z')[0]
    }`

    if (wareHouse > 0) {
      warehouseId = `&WarehouseId=${wareHouse}`
    }

    if (zone > 0) {
      zoneId = `&ZoneId=${zone}`
    }

    apiCall(
      'GET',
      `${ApiConfig.PickingRouteApi}/GetPickingReport?${initialDate}${finalDate}${warehouseId}${zoneId}`
    )
      .then((response) => {
        if (response.status === 200 && response.data !== null) {
          setPickingReportData(response.data)
          setLoading(false)
        }
      })
      .catch(({ data: { message } }) => {
        setSnackBar({
          message,
          open: true,
          status: 'error'
        })
        setLoading(false)
      })
  }

  const validateTime = () => {
    const actualDate = DateTime.fromISO(timeFilter.finalDate)
    const diff = actualDate
      .diff(DateTime.fromISO(timeFilter.initialDate).toUTC(), 'hours')
      .toObject()

    if (
      !Interval.fromDateTimes(
        DateTime.fromISO(timeFilter.initialDate).toUTC(),
        DateTime.fromISO(timeFilter.finalDate).toUTC()
      ).isValid ||
      diff.hours! > 48
    ) {
      setError(true)
    } else {
      setError(false)
    }
  }

  useEffect(() => {
    validateTime()
    handleGetDataDashBoard()
  }, [wareHouse, zone])

  useEffect(() => {
    validateTime()
  }, [timeFilter.initialDate, timeFilter.finalDate])

  const handleChangeIndicator = (indicator: any) => {
    if (indicator === enumTipoIndicador.Cantidad_de_Rutas) {
      dataVariable = pickingReportData?.items.map((x) => x.routeQty)
    } else {
      if (indicator === enumTipoIndicador.Unidades_pickeadas_por_hora) {
        dataVariable = pickingReportData?.items.map((x) => x.unitsByHour)
      } else {
        if (indicator === enumTipoIndicador.Tiempo_promedio_por_ruta) {
          dataVariable = pickingReportData?.items.map((x) => x.averageByRoute)
        } else {
          if (indicator === enumTipoIndicador.Tiempo_promedio_por_SKU) {
            dataVariable = pickingReportData?.items.map((x) => x.averageBySku)
          } else {
            if (indicator === enumTipoIndicador.Tiempo_efectivo_trabajado) {
              dataVariable = pickingReportData?.items.map(
                (x) => x.effectiveTime
              )
            }
          }
        }
      }
    }

    setDataIndicator(dataVariable!)
  }

  categories = pickingReportData?.items.map((x) => x.userName)

  dataUnidadesPickeadas = pickingReportData?.items.map((x) => x.pickedUnits)

  dataUnidadesPromedio = pickingReportData?.items.map((x) => x.averageByUnit)

  dataTiempoTrabajado = pickingReportData?.items.map((x) => x.workedTime)

  const resetState = () => {
    setZone(0)
    setWareHouse(0)
    setTimeFilter(initialData)
  }

  return loading ? (
    <Fragment>
      <Grid container spacing={3}>
        <Grid item xs={12} lg={12}>
          <Paper className={classes.paper}>
            <img
              src={graphLoader}
              alt='graph'
              style={{
                width: '211px',
                height: '200px',
                maxWidth: '211px',
                minWidth: '200px',
                opacity: '1',
                borderRadius: '100px'
              }}
            />
            <Typography
              variant='h4'
              color='textSecondary'
              component='h4'
              className={classes.textColor}
            >
              {'Generando Reporte...'}
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Fragment>
  ) : (
    <Fragment>
      <Paper className={classes.paper} elevation={2}>
        <Fade in={true}>
          <Grid
            container
            direction='row'
            justifyContent='center'
            alignItems='center'
          >
            <Grid item sm={12} lg={4}>
              <TextField
                error={error}
                helperText={error ? 'Rango de fechas no válido' : ''}
                id='initialDate'
                name='initialDate'
                value={timeFilter.initialDate}
                label='Ingrese fecha de inicio'
                onChange={handleChangeDateTime}
                type='datetime-local'
                InputLabelProps={{
                  shrink: true
                }}
              />
            </Grid>

            <Grid item sm={12} lg={4}>
              <TextField
                error={error}
                helperText={error ? 'Rango de fechas no válido' : ''}
                id='finalDate'
                name='finalDate'
                value={timeFilter.finalDate}
                onChange={handleChangeDateTime}
                label='Ingrese fecha de término'
                type='datetime-local'
                InputLabelProps={{
                  shrink: true
                }}
              />
            </Grid>

            <Grid item sm={12} lg={2}>
              <div style={{ alignSelf: 'flex-start' }}>
                <Tooltip title='Refrescar' placement='top-end'>
                  <IconButton
                    className={`${classes.button}`}
                    onClick={resetState}
                  >
                    <RefreshIcon />
                  </IconButton>
                </Tooltip>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={handleGetDataDashBoard}
                  disabled={error}
                >
                  Buscar
                </Button>
              </div>
            </Grid>

            <Grid item sm={12} lg={2} justifyContent='flex-end'>
              <Typography
                variant='body2'
                color='textSecondary'
                component='p'
                className={classes.textColor}
              >
                {`Actualizado ${new Date().getHours()}:${
                  new Date().getMinutes() > 9
                    ? new Date().getMinutes()
                    : `0${new Date().getMinutes()}`
                }`}
              </Typography>
            </Grid>

            <Grid item sm={12} lg={4}>
              <FormControl>
                <Selector
                  fullWidth={true}
                  labelId='selectedPickerWareHouse'
                  item={warehouses!.map((item) => ({
                    value: item.id,
                    name: item.warehouseName
                  }))}
                  defaultLabel='Almacén'
                  onChange={(e) => setWareHouse(e.target.value as number)}
                  id='warehouseId'
                  name='warehouseId'
                  value={wareHouse}
                />
              </FormControl>
            </Grid>

            <Grid item sm={12} lg={4}>
              <FormControl>
                <Selector
                  fullWidth={true}
                  labelId='selectedPickerZone'
                  item={zones!.map((item) => ({
                    value: item.zoneId,
                    name: item.zoneName
                  }))}
                  defaultLabel='Zona'
                  onChange={(e) => setZone(e.target.value as number)}
                  id='zoneId'
                  name='zoneId'
                  value={zone}
                />
              </FormControl>
            </Grid>

            <Grid item sm={12} lg={4}></Grid>

            <Grid item sm={12} lg={6} style={{ marginTop: '10px' }}>
              <Typography variant='h5' component='h2'>
                {'Unidades pickeadas'}
              </Typography>

              <Typography
                variant='h4'
                color='textSecondary'
                component='h4'
                className={classes.textColor}
                style={{ marginLeft: '5px' }}
              >
                {pickingReportData?.totals.pickedUnits !== undefined
                  ? `${numberWithPoints(pickingReportData?.totals.pickedUnits)}`
                  : '0'}
              </Typography>
            </Grid>

            <Grid item sm={12} lg={6}>
              <Typography variant='h5' component='h5'>
                {'Tiempo promedio por unidad '}
              </Typography>

              <Typography
                variant='h4'
                color='textSecondary'
                component='h4'
                className={classes.textColor}
              >
                {pickingReportData?.totals.averageByUnit !== undefined
                  ? `${numberWithPoints(
                      pickingReportData?.totals.averageByUnit
                    )} min.`
                  : '0 min.'}
              </Typography>
            </Grid>
          </Grid>
        </Fade>
      </Paper>

      <Paper
        className={classes.paper}
        elevation={2}
        style={{ padding: '15px' }}
      >
        <Fade in={true}>
          <Grid container spacing={1}>
            <Grid
              container
              item
              xs={12}
              lg={12}
              spacing={1}
              justifyContent='flex-start'
              alignItems='center'
            >
              <Grid item sm={12} lg={4}>
                <Typography variant='body2' color='textSecondary' component='p'>
                  Unidades pickeadas
                </Typography>
              </Grid>
              <Grid item sm={12} lg={4}>
                <Typography variant='body2' color='textSecondary' component='p'>
                  Tiempo promedio por unidad
                </Typography>
              </Grid>
              <Grid item sm={12} lg={4}>
                <Typography variant='body2' color='textSecondary' component='p'>
                  Tiempo total trabajado
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              item
              xs={12}
              lg={12}
              spacing={1}
              style={{ overflow: 'scroll', overflowX: 'hidden' }}
              className={`${classes.root} ${classes.scrollBarB}`}
            >
              <Grid item sm={12} lg={4}>
                <HorizontalBarChart
                  categories={categories}
                  data={dataUnidadesPickeadas}
                  seriesName={'U. Pickeadas'}
                  height={'400'}
                  titleXAxis={'Unidades'}
                  titleYAxis={'Trabajadores'}
                ></HorizontalBarChart>
              </Grid>
              <Grid item sm={12} lg={4}>
                <HorizontalBarChart
                  categories={categories}
                  data={dataUnidadesPromedio}
                  seriesName={'Prom. x Unidad'}
                  height={'400'}
                  titleXAxis={'Minutos'}
                  titleYAxis={matchesLG ? '' : 'Trabajadores'}
                ></HorizontalBarChart>
              </Grid>
              <Grid item sm={12} lg={4}>
                <HorizontalBarChart
                  categories={categories}
                  data={dataTiempoTrabajado}
                  seriesName={'Tiempo Trabajado'}
                  height={'400'}
                  titleXAxis={'Horas'}
                  titleYAxis={matchesLG ? '' : 'Trabajadores'}
                ></HorizontalBarChart>
              </Grid>
            </Grid>
          </Grid>
        </Fade>
      </Paper>
      <Paper
        className={classes.paper}
        elevation={2}
        style={{ padding: '15px' }}
      >
        <Fade in={true}>
          <Grid container spacing={1}>
            <Grid container item xs={12} lg={4} spacing={1}>
              <Grid item sm={12} lg={6}>
                <CardChart
                  // title={'0'}
                  subTitle={'Cantidad de Rutas totales creadas'}
                  maxHeight={cardSize.maxHeight}
                  maxWidth={cardSize.maxWidth}
                  className='counter'
                  title={
                    pickingReportData?.totals.routeQty !== undefined
                      ? `${numberWithPoints(
                          pickingReportData?.totals.routeQty
                        )}`
                      : '0'
                  }
                />
                <input
                  type='hidden'
                  className='target'
                  value={
                    pickingReportData?.totals.routeQty !== undefined
                      ? `${pickingReportData?.totals.routeQty}`
                      : '0'
                  }
                />
              </Grid>
              <Grid item sm={12} lg={6}>
                <CardChart
                  // title={'0'}
                  subTitle={'Tiempo promedio por ruta'}
                  maxHeight={cardSize.maxHeight}
                  maxWidth={cardSize.maxWidth}
                  className='counter'
                  title={
                    pickingReportData?.totals.averageByRoute
                      ? `${numberWithPoints(
                          pickingReportData?.totals.averageByRoute
                        )} min.`
                      : '0 min.'
                  }
                />
                <input
                  type='hidden'
                  className='target'
                  value={`${pickingReportData?.totals.averageByRoute}`}
                />
              </Grid>
              <Grid item sm={12} lg={6}>
                <CardChart
                  // title={'0'}
                  subTitle={'Rutas con quiebre'}
                  maxHeight={cardSize.maxHeight}
                  maxWidth={cardSize.maxWidth}
                  className='counter'
                  title={
                    pickingReportData?.totals.incompleteRoutes !== undefined
                      ? `${numberWithPoints(
                          pickingReportData?.totals.incompleteRoutes
                        )}`
                      : '0'
                  }
                />
                <input
                  type='hidden'
                  className='target'
                  value={
                    pickingReportData?.totals.incompleteRoutes !== undefined
                      ? `${pickingReportData?.totals.incompleteRoutes}`
                      : '0'
                  }
                />
              </Grid>
              <Grid item sm={12} lg={6}>
                <CardChart
                  // title={'0'}
                  subTitle={'Tiempo promedio por unidad'}
                  maxHeight={cardSize.maxHeight}
                  maxWidth={cardSize.maxWidth}
                  className='counter'
                  title={
                    pickingReportData?.totals.averageByUnit !== undefined
                      ? `${numberWithPoints(
                          pickingReportData?.totals.averageByUnit
                        )} min.`
                      : '0 min.'
                  }
                />
                <input
                  type='hidden'
                  className='target'
                  value={
                    pickingReportData?.totals.averageByUnit !== undefined
                      ? `${pickingReportData?.totals.averageByUnit}`
                      : '0'
                  }
                />
              </Grid>
              <Grid item sm={12} lg={6}>
                <CardChart
                  // title={'0'}
                  subTitle={'Rutas finalizadas'}
                  maxHeight={cardSize.maxHeight}
                  maxWidth={cardSize.maxWidth}
                  className='counter'
                  title={
                    pickingReportData?.totals.finishedRoutes !== undefined
                      ? `${numberWithPoints(
                          pickingReportData?.totals.finishedRoutes
                        )}`
                      : '0'
                  }
                />
                <input
                  type='hidden'
                  className='target'
                  value={
                    pickingReportData?.totals.finishedRoutes !== undefined
                      ? `${pickingReportData?.totals.finishedRoutes}`
                      : '0'
                  }
                />
              </Grid>
              <Grid item sm={12} lg={6}>
                <CardChart
                  // title={'0'}
                  subTitle={'Pickeadores trabajando'}
                  // subTitle2={'14 iniciada 6 cerrada'}
                  maxHeight={cardSize.maxHeight}
                  maxWidth={cardSize.maxWidth}
                  className='counter'
                  title={
                    pickingReportData?.totals.workingUsers !== undefined
                      ? `${numberWithPoints(
                          pickingReportData?.totals.workingUsers
                        )}`
                      : '0'
                  }
                />
                <input
                  type='hidden'
                  className='target'
                  value={
                    pickingReportData?.totals.workingUsers !== undefined
                      ? `${pickingReportData?.totals.workingUsers}`
                      : '0'
                  }
                />
              </Grid>
              <Grid item sm={12} lg={6}>
                <CardChart
                  // title={'0'}
                  subTitle={'Unidades totales pickeadas'}
                  maxHeight={cardSize.maxHeight}
                  maxWidth={cardSize.maxWidth}
                  className='counter'
                  title={
                    pickingReportData?.totals.pickedUnits !== undefined
                      ? `${numberWithPoints(
                          pickingReportData?.totals.pickedUnits
                        )}`
                      : '0'
                  }
                />
                <input
                  type='hidden'
                  className='target'
                  value={
                    pickingReportData?.totals.pickedUnits !== undefined
                      ? `${numberWithPoints(
                          pickingReportData?.totals.pickedUnits
                        )}`
                      : '0'
                  }
                />
              </Grid>
              <Grid item sm={12} lg={6}>
                <CardChart
                  // title={'0'}
                  subTitle={'Pickeadores totales día'}
                  maxHeight={cardSize.maxHeight}
                  maxWidth={cardSize.maxWidth}
                  className='counter'
                  title={
                    pickingReportData?.totals.totalUsers !== undefined
                      ? `${numberWithPoints(
                          pickingReportData?.totals.totalUsers
                        )}`
                      : '0'
                  }
                />
                <input
                  type='hidden'
                  className='target'
                  value={
                    pickingReportData?.totals.totalUsers !== undefined
                      ? `${pickingReportData?.totals.totalUsers}`
                      : '0'
                  }
                />
              </Grid>
            </Grid>

            <Grid
              container
              direction='column'
              justifyContent='flex-start'
              alignItems='center'
              item
              xs={12}
              lg={8}
              spacing={1}
            >
              <Grid container item sm={12} lg={12}>
                <Grid item sm={12} lg={3}></Grid>
                <Grid item sm={12} lg={1}>
                  <Box pt={3}>
                    <InputLabel id='indicadores'>Indicadores</InputLabel>
                  </Box>
                </Grid>
                <Grid item sm={12} lg={5}>
                  <Box>
                    <FormControl>
                      <Selector
                        labelId='selectedIndicadores'
                        item={EnumIndicadores.map((item) => ({
                          value: item.id,
                          name: item.name
                        }))}
                        defaultLabel=' Indicador'
                        onChange={(e) => {
                          setIndicator(e.target.value as number)
                          handleChangeIndicator(e.target.value)
                        }}
                        id='indicatorId'
                        name='indicatorId'
                        value={indicator}
                        // style={{ alignSelf: 'flex-end' }}
                      />
                    </FormControl>
                  </Box>
                  <Box pt={3}>
                    <InputLabel id='legend'>{`${
                      (indicator as number) > 0
                        ? EnumIndicadores.filter(
                            (x) => x.id === indicator.toString()
                          )[0].name
                        : ''
                    }`}</InputLabel>
                  </Box>
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  lg={2}
                  spacing={1}
                  style={{ paddingLeft: '40px' }}
                >
                  <Grid item sm={12} lg={5}>
                    <Tooltip title='Refrescar' placement='top-end'>
                      <IconButton
                        onClick={() => {
                          handleGetDataDashBoard()
                          handleChangeIndicator(indicator)
                        }}
                      >
                        <RefreshIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                  <Grid item sm={12} lg={1}>
                    <Box>
                      <PopOverMenu />
                    </Box>
                  </Grid>
                </Grid>
                <Grid
                  item
                  sm={12}
                  lg={12}
                  className={`${classes.root} ${classes.scrollBarC}`}
                >
                  <HorizontalBarChart
                    categories={categories}
                    data={
                      (indicator as number) === 1
                        ? pickingReportData?.items.map((x) => x.routeQty)
                        : dataIndicator
                    }
                    seriesName={
                      (indicator as number) > 0
                        ? EnumIndicadores.filter(
                            (x) => x.id === indicator.toString()
                          )[0].shortName
                        : ''
                    }
                    height={'480'}
                    titleXAxis={`${
                      (indicator as number) > 0
                        ? EnumIndicadores.filter(
                            (x) => x.id === indicator.toString()
                          )[0].um
                        : ''
                    }`}
                    titleYAxis={'Trabajadores'}
                  ></HorizontalBarChart>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Fade>
      </Paper>

      <SnackBar
        message={snackBar.message}
        open={snackBar.open}
        status={snackBar.status}
        setOpen={() =>
          setSnackBar({
            ...snackBar,
            open: false
          })
        }
      />
    </Fragment>
  )
}
